import React from "react";
import "./ToggleSwitch.css";

// Accessible on/off switch. Usage:
//   <ToggleSwitch checked={on} onChange={setOn} label="Lunch selection" />
export default function ToggleSwitch({ checked, onChange, label, disabled, id }) {
  return (
    <label className={`toggle-switch${disabled ? " is-disabled" : ""}`} htmlFor={id}>
      <span className="toggle-track">
        <input
          id={id}
          type="checkbox"
          role="switch"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <span className="toggle-thumb" aria-hidden="true" />
      </span>
      {label && <span className="toggle-label">{label}</span>}
    </label>
  );
}
